import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import styles from 'assets/jss/material-dashboard-pro-react/components/accordionStyle';
import { whiteColor } from 'assets/jss/material-dashboard-pro-react';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IAccordionProps {
	active?: number[];
	collapses: Array<IAccordionItem>;
	className?: string;
	enableOnBlur?: boolean;
	multiple?: boolean;
}

interface IAccordionItem {
	id?: string;
	title: React.ReactElement;
	content: React.ReactElement;
	disabled?: boolean;
	icon?: React.ReactElement;
	iconBackgroundColor?: string;
	backgroundColor?: string;
	expanded?: boolean;
}

const Accordion = ({ active = [], collapses, className, enableOnBlur, multiple }: IAccordionProps) => {
	const [activeState, setActiveState] = useState<number[]>([...active]);
	const classes = useStyles();

	const handleChange = (panel: any) => (event: any, expanded: boolean) => {
		if (multiple) {
			setActiveState((state) => {
				const updatedState = [...state];
				const index = updatedState.indexOf(panel);
				if (index >= 0) {
					updatedState.splice(index, 1);
				} else {
					updatedState.push(panel);
				}
				return updatedState;
			});
		} else {
			setActiveState(expanded ? [panel] : []);
		}
	};

	const handleBlur = (event: any) => {
		if (!event?.currentTarget?.contains(event?.relatedTarget) && enableOnBlur) {
			setActiveState([]);
		}
	};

	return (
		<div
			className={classes.root}
			tabIndex={0}
			onBlur={(e) => {
				handleBlur(e);
			}}
		>
			{collapses
				.filter((e) => e)
				.map((prop, key) => {
					return (
						<ExpansionPanel
							key={key}
							id={prop.id}
							expanded={activeState.indexOf(key) >= 0 || !!prop.expanded}
							onChange={handleChange(key)}
							classes={{
								root: classNames(classes.expansionPanel, className),
								expanded: classes.expansionPanelExpanded,
							}}
							disabled={prop.disabled}
							style={{ backgroundColor: prop.backgroundColor }}
						>
							<ExpansionPanelSummary
								expandIcon={!prop.expanded && <ExpandMore />}
								classes={{
									root: `${classes.expansionPanelSummary} ${className}`,
									expanded: classes.expansionPanelSummaryExpanded,
									content: classes.expansionPanelSummaryContent,
									expandIcon: classes.expansionPanelSummaryExpandIcon,
								}}
							>
								<ConditionalRender
									show={!!prop.icon}
									onTrue={() => (
										<div
											className={classes.iconWrapper}
											style={{ backgroundColor: prop.iconBackgroundColor || whiteColor }}
										>
											{prop.icon}
										</div>
									)}
								/>
								<div className={classes.title}>{prop.title}</div>
							</ExpansionPanelSummary>
							<ConditionalRender
								show={!!prop.content}
								onTrue={() => (
									<ExpansionPanelDetails className={classes.expansionPanelDetails}>
										{prop.content}
									</ExpansionPanelDetails>
								)}
							/>
						</ExpansionPanel>
					);
				})}
		</div>
	);
};

export default Accordion;
